/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { Tag, TagFromJSON, TagFromJSONTyped, TagToJSON } from "./Tag";

/**
 *
 * @export
 * @interface TagControllerResponse
 */
export interface TagControllerResponse {
  /**
   *
   * @type {Tag}
   * @memberof TagControllerResponse
   */
  data?: Tag;
  /**
   *
   * @type {ErrorResponse}
   * @memberof TagControllerResponse
   */
  error?: ErrorResponse;
}

export function TagControllerResponseFromJSON(json: any): TagControllerResponse {
  return TagControllerResponseFromJSONTyped(json, false);
}

export function TagControllerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : TagFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function TagControllerResponseToJSON(value?: TagControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: TagToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
